import { useState, useEffect, useCallback } from 'react';

export default function useAuditProgress(buildingId) {
    const [progress, setProgress] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const refresh = useCallback(() => {
        if (!buildingId) return;
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}/get_audit_progress/${buildingId}`)
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    setError(data.error);
                    setProgress(null);
                } else {
                    setProgress(data);
                    setError(null);
                }
            })
            .catch(err => setError(err.message))
            .finally(() => setLoading(false));
    }, [buildingId]);

    useEffect(() => { refresh(); }, [refresh]);

    return { progress, loading, error, refresh };
}
